import { FC, useState } from 'react';
import { CampaignStep } from '../types';
import { useEditorContext } from './EditorContext';
import {
  PromptState,
  UnsavedChangesPromptContext,
  UnsavedChangesPromptContextState,
} from './UnsavedChangesPromptContext';

export const UnsavedChangesPromptProvider: FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const [promptState, setPromptState] = useState<PromptState>({ openModal: false });

  const { campaignSteps, currentEditableStep } = useEditorContext();

  const transitionTo = (transferFn: () => void) => {
    if (currentEditableStep) {
      setPromptState({
        openModal: true,
        consumerCallback: transferFn,
      });
    } else {
      transferFn();
    }
  };

  const transitionToCampaignStep = (campaignStep: CampaignStep, transferFn: () => void) => {
    const campaignState = campaignSteps[campaignStep];
    if (campaignState?.isEditable) {
      setPromptState({ openModal: true, consumerCallback: transferFn });
    } else {
      transferFn();
    }
  };

  const value = {
    promptState,
    setPromptState,
    transitionToCampaignStep,
    transitionTo,
  } as UnsavedChangesPromptContextState;

  return (
    <UnsavedChangesPromptContext.Provider value={value}>
      {children}
    </UnsavedChangesPromptContext.Provider>
  );
};
